import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { heroComics } from '@/mocks/home';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20Chinese%20manga%20inspired%20abstract%20background%20with%20soft%20ink%20wash%20textures%2C%20warm%20amber%20and%20cream%20tones%2C%20subtle%20brush%20strokes%2C%20ethereal%20floating%20light%20particles%2C%20dreamy%20atmospheric%20composition%2C%20traditional%20Chinese%20art%20aesthetic%20blended%20with%20modern%20minimalism%2C%20no%20text%2C%20clean%20composition&width=1800&height=1200&seq=hero-bg-main-01&orientation=landscape"
          alt="布丁漫画网 - 洞洞杂货铺"
          title="洞洞杂货铺漫画全集下拉式免费阅读 - 布丁漫画网"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center pt-32 md:pt-40">
        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-background-50 text-center leading-tight">
          {t('home:hero_title_line1')}
          <br />
          {t('home:hero_title_line2')}
          <br />
          {t('home:hero_title_line3')}
        </h1>
        <p className="mt-5 md:mt-6 text-sm md:text-base text-background-50/80 max-w-xl text-center leading-relaxed">
          {t('home:hero_subtitle')}
        </p>
        <Link
          to="/category/fantasy"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          {t('common:read_now')}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </Link>

        <div className="mt-14 md:mt-20 flex items-end justify-center gap-3 md:gap-5">
          {heroComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className={`relative rounded-2xl overflow-hidden transition-all duration-500 hover:scale-105 cursor-pointer ${
                idx === 1
                  ? 'w-[150px] md:w-[200px] z-20 -translate-y-3 md:-translate-y-5'
                  : 'w-[120px] md:w-[160px] z-10 opacity-85 hover:opacity-100'
              }`}
              style={{
                transform: idx === 0 ? 'rotate(-4deg)' : idx === 2 ? 'rotate(4deg)' : 'none',
              }}
            >
              <div className="aspect-[3/4]">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 布丁漫画网`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                <p className="text-background-50 text-xs md:text-sm font-medium truncate">{comic.title}</p>
                <p className="text-background-50/70 text-[10px] md:text-xs mt-0.5">
                  {comic.chapters}{t('home:comic_chapters')} · {comic.rating}{t('home:comic_rating')}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}